import { render, staticRenderFns } from "./salesmanDeduction.vue?vue&type=template&id=ce01982c&scoped=true&"
import script from "./salesmanDeduction.vue?vue&type=script&lang=js&"
export * from "./salesmanDeduction.vue?vue&type=script&lang=js&"
import style0 from "./salesmanDeduction.vue?vue&type=style&index=0&id=ce01982c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce01982c",
  null
  
)

export default component.exports